export interface StationRow {
  id: number;
  stationName?: string;
  name?: string;
  callLetters?: string;
  market?: string;
}

export function stationDisplayName(s: StationRow): string {
  return (s.stationName || s.name || '').trim();
}

export function formatStationMenuLabel(s: StationRow): string {
  const name = stationDisplayName(s);
  const letters = (s.callLetters || '').trim();
  if (name && letters) return `${name} (${letters})`;
  return name || letters || `Station ${s.id}`;
}

/** Non-admin users should only see stations returned by GetUserStations (not cached admin lists). */
export function isAdminUser(user: Record<string, unknown> | null | undefined): boolean {
  if (!user) return false;
  const role = String(user.userRole ?? user.role ?? '').toLowerCase();
  if (role.includes('admin')) return true;
  const adminRights = String(user.adminRights ?? '').toLowerCase();
  return adminRights === 'true' || adminRights === '1' || adminRights.includes('admin');
}
